// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"line-height"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M13 5H21M11 12H21M13 19H21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M7.29331 6.29289L5.00041 4L2.70752 6.29289M2.70703 17.7071L4.99993 20L7.29282 17.7071M5.00041 5.3V18.75","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const LineHeightIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'line-height',
    ref,
    icon: element,
  },
));

LineHeightIcon.displayName = 'LineHeightIcon';

export default LineHeightIcon;
